import { useState } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { ButtonBrand } from 'components/ButtonBrand';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { FEDERAL, resultsList, STATE } from './constants';

export const RealResults = () => {
  const [selected, setSelected] = useState(STATE);

  return (
    <div className="real-results-header">
      <div className="real-results-title">
        <FadeText className="eyebrow-text" text="Real Results" progressive inViewTrigger />
        <FadeText
          progressive
          inViewTrigger
          delay={0.2}
          className="h2-dtm"
          text={resultsList[selected].header}
        />
        <FadeText
          inViewTrigger
          delay={0.8}
          className="h4-text"
          text={resultsList[selected].subheader}
        />
        <FadeContainer className="real-results-buttons" inViewTrigger delay={0.4}>
          <ButtonBrand
            disabled={selected === STATE}
            $secondary={selected === STATE}
            onClick={() => setSelected(STATE)}
          >
            State
          </ButtonBrand>
          <ButtonBrand
            disabled={selected === FEDERAL}
            $secondary={selected === FEDERAL}
            onClick={() => setSelected(FEDERAL)}
          >
            Federal
          </ButtonBrand>
        </FadeContainer>
      </div>
      <FadeContainer inViewTrigger delay={0.2}>
        <img
          src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/${resultsList[selected].image}`}
          alt={`${selected} candidate`}
        />
      </FadeContainer>
    </div>
  );
};
